/**
 * SleepKarma DW v2 — Embedded mini-PDP (mouth tape only).
 *
 * Standalone port of the home-v2.js mini-PDP logic, scoped to a single
 * .sk-dw-mp root on the /pages/does-mouth-taping-work page. We do NOT
 * load home-v2.js directly because it has unscoped IntersectionObservers
 * on .reveal and [data-count] that would fight with sleepkarma-shared.js.
 *
 * Variant IDs, selling-plan IDs, and pricing mirror home-v2.js exactly so
 * what's added to cart matches the homepage and live PDP.
 *
 * ATC flow: POST /cart/add.js then call <cart-drawer>.renderContents() +
 * toggleDrawerClasses() to open the theme's cart drawer (no /cart redirect).
 */
(function () {
  'use strict';

  var ROOT_SEL = '.sk-dw-mp';

  // Mouth-tape variant grid (Tape style × Frequency) — sourced from
  // assets/home-v2.js (line 768) and sleep-karma-pdp.js.
  var SK_VARIANTS = {
    'full-1': 46066516656369, 'full-3': 46072098324721, 'full-6': 46072098357489,
    'slim-1': 46066516721905, 'slim-3': 46072098390257, 'slim-6': 46072098423025
  };
  // Skio selling plans by pack tier.
  var SK_SELLING_PLANS = { '1': 5171773681, '3': 5171740913, '6': 5171806449 };

  // Mouth tape pricing — mirrors PRODUCTS_DATA.mouth in home-v2.js.
  var PRICING = {
    packs: {
      '1': { perMonth: '$49.95', total: '$49.95'  },
      '3': { perMonth: '$49.95', total: '$149.85' },
      '6': { perMonth: '$49.95', total: '$299.70' }
    },
    subPacks: {
      '1': { perMonth: '$34.97', orig: '$49.95',  total: '$34.97',  save: '30% OFF' },
      '3': { perMonth: '$27.47', orig: '$149.85', total: '$82.41',  save: '45% OFF' },
      '6': { perMonth: '$24.98', orig: '$299.70', total: '$149.88', save: '50% OFF' }
    }
  };
  var ONE_TIME_UNIT_CENTS = 4995;

  function init() {
    var root = document.querySelector(ROOT_SEL);
    if (!root) return;

    var state = { pack: '3', variant: 'full', isSubscription: true };

    function $(sel) { return root.querySelector(sel); }
    function $$(sel) { return root.querySelectorAll(sel); }

    // ---------- Pack-card pricing paint ----------
    function paintPackCards() {
      ['1', '3', '6'].forEach(function (pk) {
        var permEl = $('#mp-pack-' + pk + '-perm');
        var origEl = $('#mp-pack-' + pk + '-orig');
        var totalEl = $('#mp-pack-' + pk + '-total');
        var discountEl = $('#mp-pack-' + pk + '-discount');
        if (!permEl) return;
        if (state.isSubscription) {
          var sub = PRICING.subPacks[pk];
          permEl.innerHTML = sub.perMonth + '<span class="mp-pack-perm-label">/mo</span>';
          if (origEl) { origEl.textContent = PRICING.packs[pk].perMonth; origEl.style.visibility = 'visible'; }
          if (discountEl) { discountEl.textContent = sub.save; discountEl.style.display = ''; }
          if (totalEl) totalEl.textContent = sub.total + ' total';
        } else {
          var one = PRICING.packs[pk];
          permEl.innerHTML = one.perMonth + '<span class="mp-pack-perm-label">/pack</span>';
          if (origEl) origEl.style.visibility = 'hidden';
          if (discountEl) discountEl.style.display = 'none';
          if (totalEl) totalEl.textContent = one.total + ' total';
        }
      });
      $$('.mp-pack-deliver, .mp-pack-benefits').forEach(function (el) {
        el.classList.toggle('visible', state.isSubscription);
      });
      var bestDeal = $('.mp-pack-tag--best');
      if (bestDeal) bestDeal.style.display = state.isSubscription ? '' : 'none';
    }

    // ---------- CTA pricing + save-line paint ----------
    function paintCTA() {
      var subTotal = PRICING.subPacks[state.pack].total;
      var oneTotal = PRICING.packs[state.pack].total;
      var total = state.isSubscription ? subTotal : oneTotal;

      var priceEl = $('#mp-cta-price');
      if (priceEl) priceEl.textContent = total;
      var origEl = $('#mp-cta-orig');
      if (origEl) {
        if (state.isSubscription) { origEl.textContent = oneTotal; origEl.style.display = ''; }
        else { origEl.style.display = 'none'; }
      }
      var saveBox = $('#mp-refill-save');
      if (saveBox) {
        if (state.isSubscription) {
          var months = parseInt(state.pack, 10);
          var oneTimeCents = ONE_TIME_UNIT_CENTS * months;
          var subCents = Math.round(parseFloat(subTotal.replace('$', '')) * 100);
          var saved = ((oneTimeCents - subCents) / 100).toFixed(2);
          saveBox.textContent = 'You save $' + saved;
          saveBox.style.display = '';
        } else {
          saveBox.style.display = 'none';
        }
      }
    }

    // ---------- Variant click (tape style) ----------
    $$('.mp-variants .mp-variant').forEach(function (v) {
      v.addEventListener('click', function () {
        $$('.mp-variants .mp-variant').forEach(function (x) {
          x.classList.remove('is-selected');
          x.setAttribute('aria-checked', 'false');
        });
        v.classList.add('is-selected');
        v.setAttribute('aria-checked', 'true');
        state.variant = v.getAttribute('data-variant') || 'full';

        // Swap visible carousel to match variant
        $$('[data-carousel]').forEach(function (cr) {
          var match = cr.getAttribute('data-variant') === state.variant;
          cr.classList.toggle('is-active', match);
          if (match) cr.dispatchEvent(new CustomEvent('hero-carousel:reset'));
        });
      });
    });

    // ---------- Pack click ----------
    $$('.mp-packs .mp-pack').forEach(function (p) {
      p.addEventListener('click', function () {
        $$('.mp-packs .mp-pack').forEach(function (x) { x.classList.remove('is-selected'); });
        p.classList.add('is-selected');
        state.pack = p.getAttribute('data-pack') || '3';
        paintPackCards();
        paintCTA();
      });
    });

    // ---------- Refill toggle ----------
    var refillBtn = $('#mp-refill');
    if (refillBtn) {
      refillBtn.addEventListener('click', function () {
        state.isSubscription = !state.isSubscription;
        refillBtn.classList.toggle('is-active', state.isSubscription);
        refillBtn.setAttribute('aria-pressed', String(state.isSubscription));
        var check = $('#mp-refill-check');
        if (check) check.textContent = state.isSubscription ? '✓' : '';
        paintPackCards();
        paintCTA();
      });
    }

    // ---------- Carousels ----------
    $$('[data-carousel]').forEach(function (cr) {
      var track = cr.querySelector('[data-track]');
      var slides = cr.querySelectorAll('.hero-carousel__slide');
      var prev = cr.querySelector('[data-prev]');
      var next = cr.querySelector('[data-next]');
      var dots = cr.querySelectorAll('.hero-carousel__dot');
      var idx = 0;
      function go(n) {
        idx = Math.max(0, Math.min(slides.length - 1, n));
        var target = slides[idx];
        var px = target ? target.offsetLeft : Math.round(idx * cr.offsetWidth);
        if (track) track.style.transform = 'translate3d(' + (-px) + 'px, 0, 0)';
        dots.forEach(function (d, i) {
          var on = i === idx;
          d.classList.toggle('is-active', on);
          if (on) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
        if (prev) prev.disabled = idx === 0;
        if (next) next.disabled = idx === slides.length - 1;
      }
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
      cr.addEventListener('hero-carousel:reset', function () { go(0); });
      var startX = null;
      if (track) {
        track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
        track.addEventListener('touchend', function (e) {
          if (startX === null) return;
          var endX = (e.changedTouches[0] || {}).clientX || startX;
          var dx = endX - startX;
          if (Math.abs(dx) > 50) go(idx + (dx < 0 ? 1 : -1));
          startX = null;
        });
      }
      cr.setAttribute('aria-roledescription', 'carousel');
      if (!cr.hasAttribute('aria-label')) cr.setAttribute('aria-label', 'Product images');
      go(0);
    });

    // ---------- ATC ----------
    function buildPayload() {
      var key = state.variant + '-' + state.pack;
      var id = SK_VARIANTS[key];
      var qty = parseInt(state.pack, 10) || 1;
      var payload = { id: id, quantity: qty };
      if (state.isSubscription) payload.selling_plan = SK_SELLING_PLANS[state.pack];
      return payload;
    }

    function ajaxAdd(payload) {
      var cartDrawer = document.querySelector('cart-drawer');
      var sectionsToRender = (cartDrawer && cartDrawer.getSectionsToRender)
        ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
        : ['cart-drawer', 'cart-icon-bubble'];
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [payload], sections: sectionsToRender.join(',') })
      })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (err) { throw err; }, function () { throw new Error('cart/add ' + r.status); });
        }
        return r.json();
      })
      .then(function (data) {
        if (cartDrawer && cartDrawer.renderContents && data.sections) {
          cartDrawer.renderContents(data, true);
          setTimeout(function () { if (!cartDrawer.isOpen) cartDrawer.toggleDrawerClasses(); }, 100);
        } else {
          var trigger = document.querySelector('.wt-cart__trigger, #cart-icon-bubble, a[href="/cart"]');
          if (trigger) trigger.click();
        }
      });
    }

    var ctaBtn = $('#add-to-cart-btn');
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (ctaBtn.dataset.busy === '1') return;
        ctaBtn.dataset.busy = '1';
        var origHTML = ctaBtn.innerHTML;
        ctaBtn.innerHTML = '<span style="font-size:14px;letter-spacing:0;">Adding to cart...</span>';
        ctaBtn.style.pointerEvents = 'none';
        var payload = buildPayload();
        if (!payload.id) {
          console.error('[sk-dw-mp] no variant for state', state);
          ctaBtn.innerHTML = '<span style="font-size:14px;letter-spacing:0;">Error — try again</span>';
          setTimeout(function () { ctaBtn.innerHTML = origHTML; ctaBtn.style.pointerEvents = ''; ctaBtn.dataset.busy = ''; }, 1800);
          return;
        }
        ajaxAdd(payload).then(function () {
          ctaBtn.innerHTML = '<span style="font-size:14px;letter-spacing:0;">Added!</span>';
          setTimeout(function () { ctaBtn.innerHTML = origHTML; ctaBtn.style.pointerEvents = ''; ctaBtn.dataset.busy = ''; }, 1200);
        }).catch(function (err) {
          console.error('[sk-dw-mp] cart add failed', err);
          ctaBtn.innerHTML = '<span style="font-size:14px;letter-spacing:0;">Error — try again</span>';
          setTimeout(function () { ctaBtn.innerHTML = origHTML; ctaBtn.style.pointerEvents = ''; ctaBtn.dataset.busy = ''; }, 1800);
        });
      });
    }

    // Initial paint
    paintPackCards();
    paintCTA();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
